import { render, staticRenderFns } from "./checkout-postpaid.vue?vue&type=template&id=248f7690&scoped=true"
import script from "./checkout-postpaid.vue?vue&type=script&lang=js"
export * from "./checkout-postpaid.vue?vue&type=script&lang=js"
import style0 from "./checkout-postpaid.vue?vue&type=style&index=0&id=248f7690&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248f7690",
  null
  
)

export default component.exports